import OmsSolutions from "@/components/omsSolutions";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOneMind = () => {
  return <OmsSolutions {...WHY_ONEMIND_CONSTANTS} />;
};

export default WhyOneMind;
